const _pages = [
  "1. 未来カフェ コンセプト",
  "2. EXPRESSION CAFÉ×LARGO",
  "3. ラルゴパッケージの御提案",
  "4. コーヒーマシンのご提案",
  "5. プレミアムアイスコーヒーのご提案",
  "6. オリジナルカスタマイズコーヒーのご提案",
  "7. サステイナブルコーヒーのご提案",
  "8. 初期投資を抑えた店舗内カフェパッケージ",
  "9. ロボットカフェ",
  "10. アレンジメニューのご提案",
  "11. 充実のドリンクラインナップ",
  "12. プロメッソ",
  "13. 人手不足解決カフィテス コーヒーシステムのご提案",
  "14. UCC DRIP POD",
  "15. 自分色を表現できるデザート",
  "16. お悩み解決商品の御提案",
  "17. メニューに季節感を出しませんか？",
  "18. 各国名物料理・テイクアウト推奨商品 ユーシーシーフーヅ新商品",
  "19. ユーシーシーフーヅのネット通販",
  "20. Liveキッチン"
]

export default {
  data() {
    return {
      pages: _pages
    };
  }
};